export default "<p>Please Wait!</p>\n";